import React, { useEffect, useRef, memo } from "react";

// LatexComponent: Wraps children and rerenders MathJax if math-tex is not found
function LatexComponent({ children }: { children: any }): JSX.Element {
  const html = children?.props?.__html;
  const hasMathTex = html && html.includes("math-tex");
  return hasMathTex ? children : <InnerLatexComponent>{children}</InnerLatexComponent>;
}

// InnerLatexComponent: Handles MathJax typeset for children
function InnerLatexComponent({ children }: { children: any }): JSX.Element {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current && typeof window !== "undefined" && window.MathJax) {
      window.MathJax.typeset([ref.current]);
    }
  }, [children]);
  return <div ref={ref}>{children}</div>;
}

// LatexDetachChangeComponent: Similar to InnerLatexComponent, handles math rendering
export function LatexDetachChangeComponent({ children }: { children: any }): JSX.Element {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current && typeof window !== "undefined" && window.MathJax) {
      window.MathJax.typeset([ref.current]);
    }
  }, [children]);
  return <div ref={ref}>{children}</div>;
}

// Export the memoized version of the main component
export default memo(LatexComponent);
